import { AVAILABILITY, CLICK_SECTIONS, CLICKOUT_SUBSECTIONS } from 'constants/constants';
import { generateClickoutURL, openClickout } from 'services/clickout';
import { getCancellationPolicy, getEstablishmentById } from 'reducers/main';
import React, { Component } from 'react';
import { selectDate, selectGuests } from 'actions/searchFormActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ESTABLISHMENT_CLICKOUT_SECTIONS } from 'templates/establishment/constants';
import { getContext } from 'services/context';
import PageEstablishment from 'templates/establishment/index';
import { parseToMoment } from 'helpers/dates-helper';
import PropTypes from 'prop-types';
import { requestEstablishmentImages } from 'actions/requestActions';
import { trackEstablishmentModalAction } from 'services/tracking';


export const LOGGER_SUBSECTIONS = {
  [ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_BEST_PRICE]: CLICKOUT_SUBSECTIONS.ESTABLISHMENT_BEST_PRICE,
  [ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_PARTNER_LOGO]: CLICKOUT_SUBSECTIONS.ESTABLISHMENT_PARTNER_LOGO,
  [ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_PRICE_WINNER]: CLICKOUT_SUBSECTIONS.ESTABLISHMENT_PRICE_WINNER,
  [ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_PRICE_OTHER]: CLICKOUT_SUBSECTIONS.ESTABLISHMENT_PRICE_OTHER,
  [ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_CTA]: CLICKOUT_SUBSECTIONS.ESTABLISHMENT_CTA,
  [ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING]: CLICKOUT_SUBSECTIONS.ESTABLISHMENT_MATCHING,
};

class SeoPageEstablishmentContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: 0,
      dateArrival: props.dateArrival,
      dateLeaving: props.dateLeaving,
      images: [],
      isMounted: false,
    };
  }

  componentDidMount() {
    this.setState({ isMounted: true }); // eslint-disable-line
  }

  handleClickout(partnerId, clickFrom, sectionTrack = CLICK_SECTIONS.ESTABLISHMENT) {
    trackEstablishmentModalAction('clickout', clickFrom);
    return openClickout(partnerId, clickFrom, sectionTrack, this.props);
  }

  handleEvents({ id }, clickSection) {
    const subSectionTrack = LOGGER_SUBSECTIONS[clickSection];

    switch (clickSection) {
      case ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_BEST_PRICE:
      case ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_CTA:
      case ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING:
      case ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_PARTNER_LOGO:
      case ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_PRICE_OTHER:
      case ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_PRICE_WINNER:
        this.handleClickout(id, subSectionTrack);
        break;

      default:
        break;
    }
  }

  formatPartner(partner, i) {
    const { allPartners, searchApplied, establishment: { matching_publications: matchingPublications } } = this.props;
    const id = partner && partner.partner_id;
    const matching = matchingPublications ? matchingPublications[i] : null;
    if (!id || !allPartners[id]) return undefined;

    return {
      cancellationFee: allPartners[id].cancellation_fee,
      cancellationPolicy: partner.cancellation_policy,
      clickoutLink: matching && matching.clickout ? matching.clickout : generateClickoutURL(id, this.props, true, searchApplied),
      favicon: `/img/clickout/clickout-${id}-favicon.jpg`,
      handleClickout: name => (evt) => {
        if (evt) evt.preventDefault();
        this.handleClickout.call(this, id, name);
      },
      id,
      instantlyBooking: partner.instantly_booking,
      pricePerNight: partner.price_per_day,
      priceTotal: partner.price_total,
      visibleName: allPartners[id].visible_name,
    };
  }

  selectImages(images, partner, allPartners) {
    const id = partner && partner.id;
    if (!id || !allPartners[id]) return images.map(image => image.big);
    const partnerName = allPartners[id].name;
    const selectedImages = [];
    const firstImage = images.find(image => (image.partners && image.partners.includes(partnerName))) || images[0];
    selectedImages.push(firstImage.big);
    images.forEach(image => image.big !== firstImage.big && selectedImages.push(image.big));
    return selectedImages;
  }

  render() {
    const { establishment, breadcrumb, allPartners, hasCancellationPolicy, t } = this.props;
    if (!establishment) return null;
    const { area, city, description, features, id, latitude, licence, longitude, maxDayPrice,
      maxGuests, minDayPrice, numberOfComments, numberOfImages, partnerRating, partners,
      partnersComments, ranking, rooms, title, titlePreposition } = establishment;
    const { currentSlide, dateArrival, dateLeaving, isMounted, description: stateDescription } = this.state;
    const arrival = dateArrival ? parseToMoment(dateArrival).format('LL') : null;
    const leaving = dateLeaving ? parseToMoment(dateLeaving).format('LL') : null;
    const images = this.state.images.length ? this.state.images : this.props.establishment.images; // eslint-disable-line
    const formatedPartners = () => partners.map((partner, i) => this.formatPartner(partner, i)).filter(p => p);

    return (
      <div>
        <PageEstablishment
          allPartners={ allPartners }
          area={ area }
          areImagesLoaded={ numberOfImages === images.length }
          arrival={ arrival }
          AVAILABILITY={ AVAILABILITY }
          breadcrumb={ breadcrumb }
          city={ city }
          currentSlide={ currentSlide }
          description={ description || stateDescription }
          features={ features }
          handleEvents={ this.handleEvents.bind(this) }
          hasBigPartnersOffers={ false }
          hasCancellationPolicy={ hasCancellationPolicy }
          id={ id }
          images={ images }
          isIE={ typeof window !== 'undefined' ? global.isExplorer || global.isEdge : false }
          isMounted={ isMounted }
          isPhone={ !!global.isPhone }
          isTablet={ !!global.isTablet }
          latitude={ latitude }
          leaving={ leaving }
          licence={ licence }
          longitude={ longitude }
          maxDayPrice={ maxDayPrice }
          maxGuests={ maxGuests }
          minDayPrice={ minDayPrice }
          numberOfComments={ numberOfComments }
          numberOfImages={ numberOfImages }
          partnerRating={ partnerRating }
          partners={ formatedPartners() }
          partnersComments={ partnersComments }
          ranking={ ranking }
          recommended={ false }
          rooms={ rooms }
          t={ t }
          title={ title }
          titlePreposition={ titlePreposition }
        />
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const params = props.params ? props.params : props;
  const id = Number(params.id || (props.establishment && props.establishment.id));
  const establishment = props.establishment ? props.establishment : getEstablishmentById(state, id);
  const allPartners = props.allPartners ? props.allPartners : state.searchResultsReducer.partners;

  return {
    allPartners,
    dateArrival: state.searchFormReducer.dateArrival,
    dateLeaving: state.searchFormReducer.dateLeaving,
    destination: state.destination.name,
    establishment,
    guestsNumber: state.searchFormReducer.guestsNumber,
    hasCancellationPolicy: getCancellationPolicy(state, id),
    id,
    searchApplied: state.searchApplied,
    userIsAuthenticated: state.authReducer.authenticated,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    requestImages: requestEstablishmentImages,
    selectDate,
    selectGuests,
  }, dispatch);
}

SeoPageEstablishmentContainer.defaultProps = {
  breadcrumb: null,
  dateArrival: null,
  dateLeaving: null,
  hasCancellationPolicy: false,
};

SeoPageEstablishmentContainer.propTypes = {
  allPartners: PropTypes.shape().isRequired,
  breadcrumb: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  })),
  dateArrival: PropTypes.number,
  dateLeaving: PropTypes.number,
  establishment: PropTypes.shape({
    area: PropTypes.number,
    availability: PropTypes.number,
    cheapestPartner: PropTypes.number,
    city: PropTypes.string.isRequired,
    comments: PropTypes.arrayOf(PropTypes.shape({
      comments: PropTypes.number.isRequired,
      partner: PropTypes.string.isRequired,
      partnerId: PropTypes.number.isRequired,
    })),
    description: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.number).isRequired,
    guestsNumber: PropTypes.number,
    id: PropTypes.number.isRequired,
    images: PropTypes.arrayOf(PropTypes.shape({
      big: PropTypes.string.isRequired,
    })),
    latitude: PropTypes.number.isRequired,
    licence: PropTypes.string,
    longitude: PropTypes.number.isRequired,
    maxGuests: PropTypes.number,
    minDayPrice: PropTypes.number,
    numberOfImages: PropTypes.number.isRequired,
    partners: PropTypes.arrayOf(PropTypes.shape({
      clickout_url: PropTypes.string,
      partner_id: PropTypes.number.isRequired,
      price_per_day: PropTypes.number,
      price_total: PropTypes.number,
    })).isRequired,
    ranking: PropTypes.number,
    recommendation: PropTypes.number,
    rooms: PropTypes.number,
    title: PropTypes.string,
    titlePreposition: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }).isRequired,
  hasCancellationPolicy: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  searchApplied: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(getContext(SeoPageEstablishmentContainer));
